<template>
  <div>
    <lab-header ref="lab_header" page-name="Home"></lab-header>
    <div class="banner swiper-container swiper-container-horizontal">
      <div>
        <swiper :options="swiperOption" class="swiper">
          <swiper-slide v-for="(item, index) in this.imgUrlList" :key="index">
            <a :href="item.url"><img :src="item.imgReqUrl" class="swiper-banner-img"></a>
          </swiper-slide>
          <div slot="pagination" class="swiper-pagination"></div>
          <div slot="button-prev" class="swiper-button-prev"></div>
          <div slot="button-next" class="swiper-button-next"></div>
        </swiper>
      </div>
    </div>
    <div class="banner Mbanner swiper-container swiper-container-horizontal">
      <div>
        <swiper :options="swiperOption" class="swiper">
          <swiper-slide v-for="(item, index) in this.imgUrlList" :key="index">
            <a :href="item.url"><img :src="item.imgReqUrl" class="swiper-banner-img"></a>
          </swiper-slide>
          <div slot="pagination" class="swiper-pagination"></div>
          <div slot="button-prev" class="swiper-button-prev"></div>
          <div slot="button-next" class="swiper-button-next"></div>
        </swiper>
      </div>
    </div>
    <div class="content clear" style="text-align: left">
      <div class="Research">
        <p class="name">Research <a class="more" href="/research">Read more+</a></p>
        <div class="ResearchList clear">
          <ul>
            <li class="clear" v-for="(item, index) in researchUrlList" :key="index" :class="showResearchCard(item.rank)" @mouseover="changeFocusRank(item.rank)">
              <a :href="item.url">
                <em>{{item.rank + 1}}</em>
                <div class="title"><p>{{item.name}}</p><i></i></div>
              </a>
            </li>
          </ul>
          <div class="ResearchR">
            <div :class="showResearchR(item.rank)" v-for="(item, index) in researchUrlList" :key="index">
              <a :href="item.url">
              <img :alt="item.name"
                   :src="item.imgReqUrl"
                   :title="item.name">
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="News">
        <p class="name">News <a class="more" href="/news">Read more+</a></p>
        <ul>
          <li v-for="(item, index) in newsUrlList" :key="index">
            <a :href="`/news/${item.newsId}`" target="_blank" lang="en">{{index + 1}}.{{item.title}}</a>
          </li>
        </ul>
      </div>
    </div>
    <lab-footer></lab-footer>
  </div>
</template>
<script>
import LabHeader from '../components/public/LabHeader'
import LabFooter from '../components/public/LabFooter'
import CrambHeader from '../components/public/CrambHeader'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'Home',
  components: { CrambHeader, LabFooter, LabHeader, Swiper, SwiperSlide },
  data () {
    return {
      // imgList: [
      //   {
      //     id: 0,
      //     url: '/members',
      //     imgUrl: require('../assets/img/banners_new/banner1.png')
      //   },
      //   {
      //     id: 1,
      //     url: '/research',
      //     imgUrl: require('../assets/img/banners_new/banner2.png')
      //   },
      //   {
      //     id: 2,
      //     url: '/research',
      //     imgUrl: require('../assets/img/banners_new/banner3.png')
      //   },
      //   {
      //     id: 3,
      //     url: '/research',
      //     imgUrl: require('../assets/img/banners_new/banner4.png')
      //   },
      //   {
      //     id: 4,
      //     url: '/research',
      //     imgUrl: require('../assets/img/banners_new/banner5.png')
      //   }
      // ],
      imgUrlList: [],
      researchUrlList: [],
      newsUrlList: [],
      swiperOption: {
        speed: 2000,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      hoverRank: 0,
      // researchList: [
      //   {
      //     rank: '01',
      //     name: 'Design and Synthesis of Rosin-Based Pesticides.',
      //     url: '/research',
      //     imgUrl: require('../assets/img/research/research1.png')
      //   },
      //   {
      //     rank: '02',
      //     name: 'Research on Rosin-based Pesticide Development and Action Mechanisms.',
      //     url: '/research',
      //     imgUrl: require('../assets/img/research/research2.png')
      //   },
      //   {
      //     rank: '03',
      //     name: 'The Design of Intelligent Responsive Sustained-release Materials.',
      //     url: '/research',
      //     imgUrl: require('../assets/img/research/research3.png')
      //   }
      // ],
      newsList: [
        {
          title: '热烈祝贺李健教授被聘为《林产化学与工业》第八届编辑委员会编委',
          date: '2023-07-17',
          id: '1'
        },
        {
          title: '欢送刘美博士前往林化所联合培养',
          date: '2023-07-17',
          id: '2'
        },
        {
          title: '祝贺硕士生徐仁乐荣获“西北农林科技大学2023年校级优秀学术型硕士学位论文”',
          date: '2023-07-17',
          id: '3'
        },
        {
          title: '祝贺硕士生徐仁乐荣获“西北农林科技大学2023届校级优秀毕业生”',
          date: '2023-07-17',
          id: '4'
        },
        {
          title: '祝贺硕士生徐仁乐在Journal of Agricultural and Food Chemistry发表学术论文',
          date: '2023-07-17',
          id: '5'
        }
      ]
    }
  },
  mounted () {
    this.getImgList()
    this.getResearchList()
    this.getNewsList()
  },
  methods: {
    changeFocusRank (rank) {
      this.hoverRank = rank
    },
    showResearchCard (rank) {
      if (this.hoverRank === rank) {
        return 'clear active'
      } else {
        return 'clear'
      }
    },
    showResearchR (rank) {
      if (this.hoverRank === rank) {
        return 'Img active'
      } else {
        return 'Img'
      }
    },
    getImgList () {
      this.$axios.get('/server_api/core/home/card_info')
        .then((response) => {
          let res = response.data
          if (res.code === 0) {
            this.imgUrlList = res.data.rows
            for (var i = 0; i < res.data.total; i++) {
              this.imgUrlList[i].imgReqUrl = this.$getImgPath(this.imgUrlList[i].imgPath)
            }
          } else {
            this.$message({
              message: '获取轮播图失败',
              type: 'error'
            })
          }
        })
    },
    getResearchList () {
      this.$axios.get('/server_api/core/home/research_info')
        .then((response) => {
          let res = response.data
          if (res.code === 0) {
            this.researchUrlList = res.data.rows
            for (var i = 0; i < res.data.total; i++) {
              this.researchUrlList[i].imgReqUrl = this.$getImgPath(this.researchUrlList[i].imgPath)
            }
          } else {
            this.$message({
              message: '获取已有研究失败',
              type: 'error'
            })
          }
        })
    },
    getNewsList () {
      this.$axios.get('/server_api/core/home/news_info')
        .then((response) => {
          let res = response.data
          if (res.code === 0) {
            this.newsUrlList = res.data.rows
          } else {
            this.$message({
              message: '获取热点新闻失败',
              type: 'error'
            })
          }
        })
    }

  }
}
</script>

<style scoped>
.swiper{
    --swiper-theme-color: #475e48;/* 设置Swiper风格 */
    --swiper-navigation-color: #475e48;/* 单独设置按钮颜色 */
    --swiper-navigation-size: 40px;/* 设置按钮大小 */
}
.swiper-banner-img{
  min-height: 280px;
  max-height: 570px;
  width: 100%;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue